import React from 'react';
import { Stack, TextField } from '@mui/material';
import PhoneField from '../../Default/PhoneField';
import IntegerField from '../../Custom/IntegerField';

const StepBasicInfo = ({ formData, handleChange }) => {
  
  return (
    <Stack spacing={3}>
      <TextField
        label="Nome da Empresa"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
        autoFocus
      />
      <TextField
        label="Endereço"
        name="address"
        value={formData.address}
        onChange={handleChange}
        placeholder="Ex: Rua Exemplo, 123, Bairro, Cidade, Estado"
      />
      <PhoneField
        name="telefone"
        value={formData.telefone}
        handleChange={handleChange}
      />
      <IntegerField
        label="Horas semanais"
        name="tempoSemanal"
        value={formData.tempoSemanal}
        onChange={handleChange}
        placeholder="44"
        required
      />
    </Stack>
  )
};

export default StepBasicInfo;
